import React from "react";
import "./ProgressBarComponent.scss";

const ProgressBarComponent = (props) => {
  return <input type="range" className={`progress-bar ${props.class}`} min="0" max="100" value={props.progress}></input>;
};

export default ProgressBarComponent;
